(() => {
  const root = document.querySelector('[data-office-package]');
  if (!root) return;

  const form = root.querySelector('.opf-form');
  const quote = root.querySelector('[data-package-quote]');
  const quantity = root.querySelector('#opf-quantity');
  const priceSummary = root.querySelector('[data-opf-price-summary]');
  const mainImage = root.querySelector('[data-opf-main-image]');
  if (!form || !quote) return;

  function selectedInput() {
    return form.querySelector('input[name="id"]:checked');
  }

  function updateQuoteUrl() {
    const selected = selectedInput();
    const url = new URL(quote.getAttribute('href'), window.location.origin);
    url.searchParams.set('package', quote.dataset.productTitle || '');
    url.searchParams.set('term', selected?.dataset.term || '');
    url.searchParams.set('quantity', quantity?.value || '1');
    url.searchParams.set('monthly_price', selected?.dataset.price || '');
    url.searchParams.set('product_url', quote.dataset.productUrl || window.location.href);
    quote.setAttribute('href', `${url.pathname}${url.search}`);

    if (priceSummary && selected?.dataset.price && selected?.dataset.summaryTerm) {
      priceSummary.innerHTML = `<span>From</span><strong>${selected.dataset.price}</strong><em>per month</em><small>on a ${selected.dataset.summaryTerm} hire</small>`;
    }
  }

  form.addEventListener('change', (event) => {
    if (event.target.matches('input[name="id"]')) {
      form.querySelectorAll('.opf-term').forEach((label) => label.classList.remove('is-selected'));
      event.target.closest('.opf-term')?.classList.add('is-selected');
    }
    updateQuoteUrl();
  });

  quantity?.addEventListener('input', updateQuoteUrl);

  root.querySelectorAll('[data-opf-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!mainImage || !thumb.dataset.imageSrc) return;
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
      root.querySelectorAll('[data-opf-thumb]').forEach((item) => item.classList.remove('is-selected'));
      thumb.classList.add('is-selected');
    });
  });

  updateQuoteUrl();
})();
